export const logoSrc = `${process.env.REACT_APP__APP_PATH_PREFIX}/svg/skratch-logo-circle.svg`;
export const logoAlphaSrc = `${process.env.REACT_APP__APP_PATH_PREFIX}/svg/skratch-logo-alpha.svg`;
